import type { Meta, StoryObj } from "@storybook/react";

import { DocumentType } from "@/constants/Documents";
import type { DocumentIconProps } from "@/ui/core";
import { DocumentIcon } from "@/ui/core/";

const StoryMeta: Meta<DocumentIconProps> = {
  title: "Core/Document Icon",
  component: DocumentIcon,
  argTypes: {
    documentType: {
      control: "select",
      options: Object.values(DocumentType),
    },
    isInvalid: { control: { type: "boolean" } },
    isLoading: { control: { type: "boolean" } },
  },
  args: {
    documentType: DocumentType.Generic,
  },
};

type Story = StoryObj<DocumentIconProps>;

const Generic: Story = {};
const Invalid: Story = {
  args: {
    isInvalid: true,
  },
};
const Loading: Story = {
  args: {
    isLoading: true,
  },
};

export default StoryMeta;
export { Generic, Invalid, Loading };
